import { render, staticRenderFns } from "./CourseStudents.vue?vue&type=template&id=5b0e5d5a"
import script from "./CourseStudents.vue?vue&type=script&lang=js"
export * from "./CourseStudents.vue?vue&type=script&lang=js"
import style0 from "./CourseStudents.vue?vue&type=style&index=0&id=5b0e5d5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports